import "../styles/sidePopUp.css";
import React, { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5"; 

const onClose = () => {
  document.querySelector(".right-popup").classList.remove("visible");
};


const SidePopUp = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 620); 
    };

    handleResize(); 
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function openMfcWebsite() {
    window.open("https://www.myfinanceclaim.com/", "_blank");
  }


  return (
    <div className={`right-popup visible`}>
      <div className="popup-image">
        <div className="text-white">
           <p className="text-bold">Acquired a vehicle on finance/lease between April 2007 and January 2021?</p>
        </div>
     
      </div>
      <div className="popup-content">
        
        <button onClick={onClose} className="close-button">
          <IoClose size={30} aria-label="Close" /> 
        </button>
        <p className="mb20">Although the deadline for diesel emissions claims has passed, there's still a chance for compensation. The Financial Conduct Authority (FCA) has revealed widespread mis-selling of UK car finance agreements, including PCP and HP contracts.</p>
        <div className="mb20">
          <button className="mfc-btn" onClick={openMfcWebsite}>Find out more</button>
        </div>
        <p className="mb20">Dealerships were found to have manipulated interest rates to increase their commission, potentially costing consumers thousands. This claim includes petrol, diesel, hybrid or electric vehicles. If you weren't fully informed about the terms or costs of agreement, you could be owed thousands in compensation.</p>
     
       
      </div>
    </div>
  );
};

export default SidePopUp;
